<template>
  <div>
    <template v-if="loading">
      <div
        class="d-flex vertical-center justify-content-center align-items-center"
        style="height: 840px; display: flex"
      >
        <LoadingMDL />
      </div>
    </template>
    <template v-else>
      <Finish
        :ifImage="false"
        :imgUrl="imgUrl"
        :message="score"
        :showbtn="true"
        @nextRoute="nextRouteFunction()"
      />
    </template>
  </div>
</template>

<script>
import Finish from '@/components/elements/Finish';
import {mapGetters} from 'vuex';
import LoadingMDL from '@/components/loading/LoadingMDL';
import TEMPLATE from '../../../TEMPLATE.vue';

export default {
  name: 'MF01',
  components: {Finish, LoadingMDL},
  props: {
    TEMPLATE,
  },
  data() {
    return {
      text: '00/50',
      imgUrl:
        'https://cdn4.iconfinder.com/data/icons/ionicons/512/icon-image-512.png',
      currentRoute: '',
      loading: true,
      navigate: [],
      score: '',
      templateData: [],
      condition: [],
      startTime: this.$helpers.getDateFormat(),
      code: '',
      section: '',
      v3Data: null,
      v3DisplayScore: null,
    };
  },
  methods: {
    nextRouteFunction: function () {
      this.loading = true;
      // this.$store.dispatch('template/commitUserProgressChinese2', {
      //   // code: "605418cb883ae722ba1b0c5f",
      //   code: this.code,
      //   codeTemplate: this.templateData.templateData.codeTemplate,
      //   contentId: this.templateData.criteria._id,
      //   answering: [],
      //   startTime: this.startTime,
      //   endTime: this.$helpers.getDateFormat(),
      //   condition: this.condition,
      //   chapter:
      //     this.templateData.chapter == undefined
      //       ? null
      //       : this.templateData.chapter,
      //   topic: this.templateData.topicPosition,
      // });

      // // ส่วนนี้เป็นส่วนของการบันทึกข้อมูลไปยัง DB โดยส่งข้อมูลไปยัง backend ในรูปแบบนี้โดยไม่ต้องรอค่ารีเทิร์น
      const data = [
        {
          codeItem: this.v3Data.codeItem,
          courseId: this.$store.state.necessary.learningCourse,
          template: this.v3Data.templateID,
          section: this.$store.state.v3.v3EnrollData.data.section,
          content: this.v3Data.content,
          type: this.v3Data.type,
          answering: [], // ถ้าหน้าไหนมีแบบฝึกหัดให้เพิ่มส่วนนี้มาด้วย (ต้องอ้างอิงฟอร์มข้ออันเดิม)
          progress: 100,
          score: 0,
          maxScore: 0,
        },
      ];
      this.$store.dispatch('v3/saveContent', data);
      // this.$store.commit('v3/clearScore');
      // //===========================================================

      const str = this.navigate.next.action.split('-');
      const path = `/v3/${str[0]}/${str[1]}`;

      this.$router.push(path);
    },
    onLoadData() {
      this.loading = true;

      this.currentRoute = this.$route.name + '-' + this.$route.params.id;
      this.courseData = this.$store.getters['necessary/getLerningCourse'];
      this.code = this.courseData._id;
      this.section = this.$store.getters['necessary/getUserCourseSection'];

      this.$store.dispatch('v3/fetchTemplateByCode', this.currentRoute);
    },
  },
  computed: {
    ...mapGetters({
      // getTemplateAndProgress: 'template/getTemplateAndProgress',
      // getResponseStatus: 'template/getResponseStatus',
      saveScoreAndProgress: 'v3/saveScoreAndProgress',
      getTemplatev3: 'v3/getTemplates',
    }),
  },
  watch: {
    getTemplatev3: function (val) {
      if (!val) return;

      this.v3Data = val;
      const template = val.templates[0];

      this.navigate = template.navigate;
      //stamp payload
      const payload = [
        {
          codeItem: this.$store.state.v3.mainCodeItem,
          courseId: this.$store.state.necessary.learningCourse,
          template: this.v3Data.templateID,
          section: this.$store.state.v3.v3EnrollData.data.section,
          content: this.v3Data.content,
          type: this.v3Data.type,
          answering: [], // ถ้าหน้าไหนมีแบบฝึกหัดให้เพิ่มส่วนนี้มาด้วย (ต้องอ้างอิงฟอร์มข้ออันเดิม)
          progress: 100,
          score: 0,
        },
      ];
      //
      this.$store.dispatch('v3/saveScoreAndProgress', payload);

      this.loading = false;
    },
    // getTemplateAndProgress: function (value) {
    //   let userScore = String(value.calcualteScore.score).padStart(2, '0');
    //   let maxScore = String(value.calcualteScore.from).padStart(2, '0');
    //   this.score = userScore + '/' + maxScore;
    //   if (value.criteria.condition.criteriaType.length != 0) {
    //     this.condition.push({
    //       criteria: value.criteria.condition.criteriaType[0]._id,
    //       val: value.criteria.condition.criteriaType[0].val,
    //     });
    //   }
    //   this.navigate = value.templateData.navigate;
    //   this.templateData = value;
    //   this.loading = false;
    // },
    // getResponseStatus: async function (value) {
    //   if (value.status == 200) {
    //     let route = this.navigate.next.action.split('-');
    //     this.$router.push('/' + route[0] + '/' + route[1]);
    //   }
    // },
    saveScoreAndProgress: async function (value) {
      console.log('Life cycle...Watch', value);

      if (value.length == 0) {
        return console.log('No data is call');
      }

      value = value[0];

      let userScore = String(value.totalScore).padStart(2, '0');
      let maxScore = String(value.maxScore).padStart(2, '0');
      this.score = userScore + '/' + maxScore;
    },
  },
  created() {},
  mounted() {
    // let payload = {
    //   templateCode: this.currentRoute,
    //   // code: "605418cb883ae722ba1b0c5f",
    //   code: this.code,
    //   // section: "testing",
    //   section: this.section,
    //   calculate_score: true,
    // };
    // this.$store.dispatch('template/fetchTemplateAndProgress', payload);
    this.onLoadData();
    console.log(this.score);
  },
  beforeDestroy() {},
};
</script>

<style scoped lang="scss"></style>
